import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

/**
 * LlmThread but only what the client needs.
 */

export const llmThreadLiteSchema = z.object({
  _id: zExt.objectId(),
  agentName: z.string(),
  versionedAgentId: zExt.objectId(),
  team: zExt.objectId(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type LlmThreadLite = z.infer<typeof llmThreadLiteSchema>;
